import insuranceLogoMapper, {
    insuranceCompanyLogoChecker
} from 'utils/insurance-logo-mapper/insurance-logo-mapper';

import Image from 'core/image';
import PropTypes from 'prop-types';
import RateOptionHeader from './rate-option-header';
import SliderIndicator from './slider-indicator';
import styles from 'styles/LandingComponents.module.scss';
import { useTranslations } from 'next-intl';
import ViewMoreWrapper from 'components/landing/view-more-wrapper/wrapper';

const RateTableItem = ({ data, scale, culture = 'es-ar' }) => {
    const t = useTranslations('top-rated-car-insurance.headers');
    const logo = insuranceLogoMapper(data.code, culture, 'colored');
    const isLogo = insuranceCompanyLogoChecker(data.code, culture, 'colored');

    return (
        <div className={styles.landing__range_table_item}>
            <div className={styles.range_table__child_logo}>
                <RateOptionHeader
                    icon="shield"
                    label={t('car-insurance-company')}
                />
                <>
                    {logo && (
                        <Image
                            src={logo}
                            alt={`${data.name} Logo`}
                            width={isLogo ? 200 : 170}
                            height={isLogo ? 60 : 45}
                        />
                    )}
                    {!isLogo && (
                        <p className={styles.company_name_item}>{data.name}</p>
                    )}
                </>
            </div>
            <div className={styles.range_table__child}>
                <RateOptionHeader
                    icon="checked-shield"
                    label={t('claim-satisfaction')}
                />
                <SliderIndicator
                    marginTop={1.5}
                    scale={scale}
                    width={175}
                    value={data.csr}
                />
            </div>
            <div className={styles.range_table__child}>
                <RateOptionHeader
                    icon="diamond"
                    label={t('financial-strength')}
                />
                <SliderIndicator
                    marginTop={1.5}
                    scale={scale}
                    width={175}
                    value={data.fsr}
                />
            </div>
            <div className={styles.range_table__child}>
                <RateOptionHeader
                    icon="smile-face"
                    label={t('customer-satisfaction')}
                />
                <SliderIndicator
                    marginTop={1.5}
                    scale={scale}
                    width={175}
                    value={data.cusr}
                />
            </div>
        </div>
    );
};

const RateTableVertical = ({ data, scale, culture }) => {
    if (!data) {
        return null;
    }

    return (
        <ViewMoreWrapper
            initialItems={4}
            itemsDelta={4}
            className={styles.landing__range_table_vertical_wrapper}
        >
            {data.map((item, index) => (
                <RateTableItem
                    key={index}
                    scale={scale}
                    data={item.company}
                    culture={culture}
                />
            ))}
        </ViewMoreWrapper>
    );
};
const CompanyData = PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    company_logo: PropTypes.object,
    csr: PropTypes.number,
    fsr: PropTypes.number,
    cusr: PropTypes.number
});
const ItemData = PropTypes.shape({
    company: CompanyData,
    quotation: PropTypes.object
});

RateTableItem.propTypes = {
    culture: PropTypes.string,
    data: CompanyData,
    scale: PropTypes.number
};

RateTableVertical.propTypes = {
    culture: PropTypes.string,
    data: PropTypes.arrayOf(ItemData),
    scale: PropTypes.number
};

export default RateTableVertical;
